var map = {
	"./photo_02.webp": 9461,
	"./photo_03.webp": 1875,
	"./photo_04.webp": 8101,
	"./photo_05.webp": 1988,
	"./photo_06.webp": 4061,
	"./photo_07.webp": 1809,
	"./photo_08.webp": 1540,
	"./photo_09.webp": 8400,
	"./photo_10.webp": 1163,
	"./photo_11.webp": 2020
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 592;